module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai470-6485853a0516553abb6d10d0dfae33ea.jpg";